import { useMutation } from '@tanstack/react-query';
import { loaders } from './files.loaders';
import { converters } from './files.converters';

export const useUploadFile = () => {
  return useMutation(loaders.uploadFile);
};

export const useDownloadFile = () => {
  return useMutation(loaders.downloadFile, {
    onSuccess: converters.export,
  });
};

export const useDownloadPdf = () => {
  return useMutation(loaders.getPdfBlob, {
    onSuccess: async (blob, { filename }) => {
      return converters.download(blob, `${filename}.pdf`);
    },
  });
};

export const useGenerateQrCodeDataUrl = () => {
  return useMutation(loaders.generateQrCodeDataUrl);
};
